import { useCallback, useEffect, useState } from 'react'
import settings from '../settings'

/* eslint-disable no-underscore-dangle */
const verifyCustomer = async ({
  email,
  phoneNumber,
  meetingType,
  storeId,
  code = undefined,
  sendCode = undefined,
}) => {
  try {
    const response = await fetch(
      `${settings.badaAppointmentApiUrl}/verification/?brand=${settings.brand}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: window.__OMNI__?.access_token
            ? `bearer ${window.__OMNI__.access_token}`
            : undefined,
        },
        body: JSON.stringify({
          email,
          phoneNumber,
          meetingType,
          storeId,
          code,
          sendCode,
        }),
      }
    )
    return await response.json()
  } catch (e) {
    return { success: false, message: 'error' }
  }
}

export const useVerification = ({
  enabled,
  email,
  phoneNumber,
  storeId,
  meetingType,
}) => {
  const [initialized, setInitialized] = useState(false)
  const [
    {
      message,
      success,
      token,
      id,
      type,
      storeVerification,
      meetingTypeVerification,
    },
    setResult,
  ] = useState({
    message: '',
    success: false,
    token: '',
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setInitialized(false)
  }, [email, phoneNumber])

  const init = useCallback(async () => {
    const result = await verifyCustomer({
      email,
      phoneNumber,
      storeId,
      meetingType,
      sendCode: true,
    })
    setResult(result)
  }, [email, phoneNumber, storeId, meetingType])

  const verify = useCallback(
    async ({ code }) => {
      setLoading(true)
      const result = await verifyCustomer({
        email,
        phoneNumber,
        storeId,
        meetingType,
        code,
      })
      setLoading(false)
      setResult(result)
      return result
    },
    [email, phoneNumber, storeId, meetingType]
  )

  const resendCode = useCallback(async () => {
    const result = await verifyCustomer({
      email,
      phoneNumber,
      storeId,
      meetingType,
      sendCode: true,
    })
    setResult(result)
  }, [email, phoneNumber, storeId, meetingType])

  useEffect(() => {
    if (!enabled || initialized) {
      return
    }
    setInitialized(true)
    init()
  }, [init, enabled, initialized])

  return {
    message,
    success,
    token,
    loading,
    id,
    type,
    storeVerification,
    meetingTypeVerification,
    verify,
    resendCode,
  }
}
